import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=4672f58e"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=4672f58e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports